export default __webpack_public_path__ + "static/media/getbannerbottom2.216e697531245c57f5bf668554ae2562.svg";